import { render, staticRenderFns } from "./backend-user.vue?vue&type=template&id=315152c6&"
import script from "./backend-user.vue?vue&type=script&lang=js&"
export * from "./backend-user.vue?vue&type=script&lang=js&"
import style0 from "./backend-user.vue?vue&type=style&index=0&id=315152c6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports